/* hk.js: generated from the design artifact. Do not edit by hand. */


(function(){
  var car = document.getElementById('heroCar');
  if(!car) return;
  var slides = Array.prototype.slice.call(car.querySelectorAll('.cslide'));
  var dotsWrap = document.getElementById('carDots');

  slides.forEach(function(_, i){
    var b = document.createElement('button');
    b.className = 'cdot';
    b.setAttribute('aria-label', 'Go to slide ' + (i + 1));
    b.setAttribute('aria-current', i === 0 ? 'true' : 'false');
    b.addEventListener('click', function(){ go(i); });
    dotsWrap.appendChild(b);
  });
  var dots = Array.prototype.slice.call(dotsWrap.children);

  function go(i){
    i = Math.max(0, Math.min(slides.length - 1, i));
    car.scrollTo({ left: car.clientWidth * i, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
  }
  function current(){ return Math.round(car.scrollLeft / car.clientWidth); }
  function mark(){
    var n = current();
    dots.forEach(function(d, i){ d.setAttribute('aria-current', i === n ? 'true' : 'false'); });
  }
  car.addEventListener('scroll', function(){
    window.clearTimeout(car._t); car._t = window.setTimeout(mark, 90);
  });
  document.getElementById('carPrev').addEventListener('click', function(){ go(current() - 1); });
  document.getElementById('carNext').addEventListener('click', function(){ go(current() + 1); });
})();

(function(){
  var DATA = {
    1:["Poor","Bone structure of the withers, shoulders and neck is easy to see. Ribs, tailhead and hip bones project prominently, and there is no fatty tissue to feel."],
    2:["Very thin","A slight covering over the base of the spine. Ribs, tailhead and hips are still prominent, and the withers and shoulders are faintly discernible."],
    3:["Thin","A slight layer of fat over the ribs, though the ribs are easily discernible. The tailhead is prominent but the individual vertebrae are no longer visible."],
    4:["Moderately thin","A faint outline of the ribs shows. There is a slight ridge along the back, fat can be felt around the tailhead, and the hip bones are not obvious. This is where a lot of hard keepers live."],
    5:["Moderate","Ribs cannot be seen but are easily felt. The back is level, the tailhead feels spongy, and the shoulders and neck blend smoothly into the body. Most programs aim here."],
    6:["Moderately fleshy","There may be a slight crease down the back. The fat over the ribs feels spongy and fat is starting to deposit along the sides of the withers and neck."],
    7:["Fleshy","A crease down the back. Individual ribs can still be felt, but with noticeable fat filling between them, and fat is building along the neck and behind the shoulder."],
    8:["Fat","Ribs are difficult to feel. The area along the withers is filled with fat, the neck has thickened and the inner thighs press together."],
    9:["Extremely fat","An obvious crease down the back, patchy fat over the ribs, bulging fat along the neck and withers, and the flank filled in flush."]
  };
  var score = document.getElementById('scaleScore'),
      desc  = document.getElementById('scaleDesc'),
      ticks = Array.prototype.slice.call(document.querySelectorAll('.tick'));

  function pick(n){
    ticks.forEach(function(t){ t.setAttribute('aria-selected', t.dataset.score === String(n) ? 'true' : 'false'); });
    score.textContent = n + '. ' + DATA[n][0];
    desc.textContent  = DATA[n][1];
  }
  ticks.forEach(function(t){
    t.addEventListener('click', function(){ pick(Number(t.dataset.score)); });
    t.addEventListener('keydown', function(e){
      var i = ticks.indexOf(t), n = null;
      if(e.key === 'ArrowRight') n = Math.min(ticks.length - 1, i + 1);
      if(e.key === 'ArrowLeft')  n = Math.max(0, i - 1);
      if(n !== null){ e.preventDefault(); ticks[n].focus(); pick(Number(ticks[n].dataset.score)); }
    });
  });
})();

/* one video at a time; the overlay hands off to native controls.
   Captions are built in JS because .vtt is not a servable type here. */
var VIDEO_CUES = {"vidSemach": [[0.37, 5.57, "Hello, my name is Jennifer Semach and I'm the founder\nand executive director of Walk About Farm"], [5.57, 11.33, "Therapeutic Riding Association, here in Minden,\nOntario. This is our good friend Casey,"], [11.33, 17.49, "who we adopted a year and a half ago for\nrehabilitation. Unfortunately, he came to us"], [17.49, 25.25, "in very poor condition. 350 pounds underweight,\narthritic hocks and inflamed joints. He had open"], [25.33, 30.85, "sores and lesions, not to mention rain rot.\nA good friend of ours recommended Smart Earth"], [30.85, 37.49, "Camelina Oil, and we are astounded with the recovery\nand progress he's made in the last year and a half."], [37.49, 43.97, "Casey definitely is a testament to Smart Earth\nCamelina Oil. He's moving better,"], [43.97, 48.29, "he's looking better, he's put on weight and his\nskin is much healthier. We would definitely"], [48.29, 52.7, "recommend this product for you and your hard keeper."]], "vidMartin": [[0.18, 7.54, "Hi, this is Thunder Mountain Equine Rescue.\nWe're in Enumclaw, Washington, and this is Gertie."], [7.54, 16.4, "She's a 31-year-old Thoroughbred mare who had\nlost a lot of weight, and this last summer"], [16.66, 24.58, "we couldn't keep any weight on her.\nShe was colicking. So as a last"], [24.66, 36.18, "resort we decided to try this Camelina oil by\nSmart Earth and see if we could get some weight"], [36.18, 43.7, "on her. And now she's 1,300 pounds,\ngot all her spunk back."]]};
(function(){
  var vids = Array.prototype.slice.call(document.querySelectorAll('.vmedia video'));
  vids.forEach(function(v){
    var overlay = document.querySelector('.vplay[data-for="' + v.id + '"]');
    var cues = VIDEO_CUES[v.id];
    if (cues && window.VTTCue) {
      var track = v.addTextTrack('captions', 'English', 'en');
      cues.forEach(function(c){ track.addCue(new VTTCue(c[0], c[1], c[2])); });
      track.mode = 'showing';
    }
    function start(){ v.controls = true; var pr = v.play(); if (pr) pr.catch(function(){}); }
    if (overlay) overlay.addEventListener('click', start);
    v.addEventListener('play', function(){
      if (overlay) overlay.hidden = true;
      vids.forEach(function(o){ if (o !== v) o.pause(); });
    });
    v.addEventListener('pause', function(){
      if (overlay && v.currentTime === 0) overlay.hidden = false;
    });
  });
})();

/* comparison table: on phones, camelina vs one feed at a time */
(function(){
  var t = document.getElementById('cmpTable');
  if (!t) return;
  var btns = document.querySelectorAll('.cmp-pick button');
  btns.forEach(function(b){
    b.addEventListener('click', function(){
      t.setAttribute('data-show', b.dataset.show);
      btns.forEach(function(o){ o.setAttribute('aria-pressed', o === b ? 'true' : 'false'); });
    });
  });
})();

function hkImg(n){ return (window.HK_IMG && window.HK_IMG[n]) || n; }

/* buy block: size selector drives the gallery, price-per-day, shipping line and CTA */
(function(){
  var SIZES = {
    jug: { name:'1 gallon jug',   price:'$74.99',  day:'$2.74', supply:'about a 1-month supply',
           qty:'1 \u00d7 1 gallon', free:false,
           imgs:[[hkImg('hk-pdp-jug.jpg'),'1-gallon jug of Camelina Oil on a tack-room floor'],
                 [hkImg('hk-buy-label.jpg'),'The jug label and pump, close up'],
                 [hkImg('hk-r04-pump-bucket.jpg'),'Camelina Oil pumped from the jug into a feed bucket']] },
    p35: { name:'3.5 gallon pail', price:'$194.99', day:'$1.77', supply:'about a 3.5-month supply',
           qty:'1 \u00d7 3.5 gallons', free:true,
           imgs:[[hkImg('hk-pdp-pail35.jpg'),'3.5-gallon pail of Camelina Oil in a barn aisle'],
                 [hkImg('hk-buy-label.jpg'),'The label and pump, close up'],
                 [hkImg('hk-r03-laura-pail-lid.jpg'),'A horse licking the lid of a Camelina Oil pail']] },
    p5:  { name:'5 gallon pail',   price:'$259.99', day:'$1.65', supply:'about a 5-month supply',
           qty:'1 \u00d7 5 gallons', free:true,
           imgs:[[hkImg('hk-pdp-pail5.jpg'),'5-gallon pail of Camelina Oil in a barn aisle'],
                 [hkImg('hk-buy-label.jpg'),'The label and pump, close up'],
                 [hkImg('hk-r03-laura-pail-lid.jpg'),'A horse licking the lid of a Camelina Oil pail']] }
  };
  var key = 'jug', idx = 0;
  var img = document.getElementById('galImg'), thumbs = document.getElementById('galThumbs');
  var ship = document.getElementById('ofShip'), btn = document.getElementById('ofBtn');
  var nudge = document.getElementById('ofNudge');
  if (!img) return;

  function paintGallery(){
    var set = SIZES[key].imgs;
    if (idx >= set.length) idx = 0;
    if (idx < 0) idx = set.length - 1;
    img.src = set[idx][0]; img.alt = set[idx][1];
    thumbs.textContent = '';
    set.forEach(function(pair, i){
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'thumb'; b.setAttribute('role','tab');
      b.setAttribute('aria-current', i === idx ? 'true' : 'false');
      b.setAttribute('aria-label', pair[1]);
      var t = document.createElement('img'); t.src = pair[0]; t.alt = '';
      b.appendChild(t);
      b.addEventListener('click', function(){ idx = i; paintGallery(); });
      thumbs.appendChild(b);
    });
  }
  function paint(){
    var d = SIZES[key];
    ship.hidden = !d.free;
    nudge.hidden = d.free;
    btn.textContent = 'Buy now \u00b7 ' + d.price;
    if (window.HK_BUY && window.HK_BUY[key]) btn.setAttribute('href', window.HK_BUY[key]);
    var pn = document.getElementById('ofPump');
    if (pn) pn.textContent = 'Free pump included, a ' + (key === 'jug' ? '$7.99' : '$9.99') + ' value';
    Array.prototype.forEach.call(document.querySelectorAll('.size'), function(el){
      el.setAttribute('data-on', el.dataset.k === key ? '1' : '0');
    });
    idx = 0; paintGallery();
  }
  /* phone sticky bar: once a size is picked it carries that size's price, matching the buy button */
  var stickyBar = document.getElementById('stickyBar');
  var stickyLink = stickyBar && stickyBar.querySelector('a');
  function paintSticky(){
    if (stickyLink) stickyLink.textContent = 'Buy now \u00b7 ' + SIZES[key].price;
  }
  /* and it gets out of the way while the buy section (with its own button) is on screen */
  var buySec = document.getElementById('buy');
  if (stickyBar && buySec && 'IntersectionObserver' in window) {
    new IntersectionObserver(function(es){
      stickyBar.classList.toggle('is-off', es[0].isIntersecting);
    }).observe(buySec);
  }
  Array.prototype.forEach.call(document.querySelectorAll('.size input'), function(r){
    r.addEventListener('change', function(){ key = r.value; paint(); paintSticky(); });
  });
  document.getElementById('ofSwitch').addEventListener('click', function(){
    var r = document.querySelector('.size input[value="p35"]');
    r.checked = true; key = 'p35'; paint(); paintSticky(); r.focus();
  });
  document.getElementById('galPrev').addEventListener('click', function(){ idx--; paintGallery(); });
  document.getElementById('galNext').addEventListener('click', function(){ idx++; paintGallery(); });
  paint();
})();
